<script>
import CallDialogLink from './CallDialogLink.vue';
export default {
  name: 'CallDialogConfirm',
  mixins: [CallDialogLink],
  props: {
    confirmationMessage: {
      type: String,
      required: true,
    },
  },
  mounted() {
    EventBus.listen('confirm-dialog-' + this.id + '-called', responseObject => {
      EventBus.fire('top-alert', {
        id: 'alert-dialog-' + this.id,
        message: this.confirmationMessage,
      });
    });
  },
};
</script>
